import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import ProductsPage from './pages/ProductsPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import AccessibilityPage from './pages/AccessibilityPage';
import { ErrorBoundary } from './components/shared/ErrorBoundary';
import { ContentProvider } from './providers/ContentProvider';
import NotFoundPage from './pages/NotFoundPage';

const AdminPage = React.lazy(() => import('./pages/AdminPage'));

const appTree = (
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Routes>
          <Route element={<ContentProvider />}>
            <Route path="/" element={<App />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/accessibility" element={<AccessibilityPage />} />
          </Route>
          <Route path="/admin" element={
            <React.Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}><div style={{ textAlign: 'center' }}><div style={{ fontSize: '2rem', marginBottom: '1rem' }}>Loading admin...</div></div></div>}>
              <AdminPage />
            </React.Suspense>
          } />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);

const rootElement = document.getElementById('root') as HTMLElement;

// Always use createRoot. The pre-rendered HTML (from scripts/prerender.js)
// is only for SEO crawlers that don't execute JS. We cannot hydrate because
// the initial client render starts with loading: true (from useContentFromDB)
// which doesn't match the fully-rendered pre-rendered HTML, causing React 19
// to throw a hydration mismatch error.
ReactDOM.createRoot(rootElement).render(appTree);
